<template>

    <dialogs-base :show.sync="dialog" max-width="20%">

        <template v-slot:activator="{ on, attrs }">  
          <v-text-field
            v-model="dateFormatted"
            :label="label"
            readonly
            v-bind="attrs"
            v-on="on"
            :error-messages="errorMessages" 
            :hide-details="errorMessages ? false : true"
            :outlined="outlined"
            :dense="dense"
          >
            <template v-slot:append>
                <v-icon small>mdi-calendar-today</v-icon>
            </template>
        </v-text-field>

        </template>

        <template v-slot:body>
            <v-date-picker v-model="date" scrollable>
                <v-spacer></v-spacer>
                <ButtonsText label="Cancelar" color="error" @click="dialog = false" />
                <ButtonsText label="Confirmar" @click="closeDialog" />
            </v-date-picker>
        </template>
    </dialogs-base>

</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch } from 'vue'
import { useFilters } from '@/composables/useFilters'

const { formatDate, parseDate } = useFilters()

const props = defineProps({
    value: { type: String },
    label: { type: String, required: false },
    errorMessages:  { type: Array, required: false },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
})

const emit = defineEmits(['input'])
const date = ref(parseDate(props.value))
const dialog = ref(false)

const model = computed({
    get: () => props.value
})

const dateFormatted = computed(() => {
    return formatDate(model.value)
})

watch(() => props.value, (newValue) => {
    date.value = parseDate(newValue)
})

function closeDialog() {
    emit('input', date.value)
    dialog.value = false
}

</script>